export default __webpack_public_path__ + "static/media/cases2@2x.0c3b470c.webp";